// Auto-generated from compiled_styleguide.json
// Do not edit directly - modify source JSON5 files instead

export const anchor = {
	"icon_size": "12px",
	"icon_padding": "6px",
	"icon_stroke": 1
};

export const button = {
	"border_size__v1": "0px",
	"border_size__v2": "1px",
	"border_radius__s1": "50px",
	"border_radius__s2": "50px",
	"border_radius__s3": "50px",
	"padding__s1_x": "24px",
	"padding__s1_y": "16px",
	"icon_margin__s1": "-4px",
	"text_offset_y__s1": "0.05em",
	"padding__s2_x": "16px",
	"padding__s2_y": "8px",
	"icon_margin__s2": "-4px",
	"text_offset_y__s2": "0.05em",
	"padding__s3_x": "10px",
	"padding__s3_y": "6px",
	"icon_margin__s3": "-2px",
	"text_offset_y__s3": "0.05em",
	"icon_size__s1": "icon.icon_size__s3",
	"icon_size__s2": "20px",
	"icon_size__s3": "icon.icon_size__s5",
	"icon_stroke__s1": 1.5,
	"icon_stroke__s2": 1,
	"icon_stroke__s3": 1,
	"icon_gap__s1": "12px",
	"icon_gap__s2": "10px",
	"icon_gap__s3": "6px",
	"icon_only_padding__s1_x": "10px",
	"icon_only_padding__s1_y": "10px",
	"icon_only_padding__s2_x": "6px",
	"icon_only_padding__s2_y": "6px",
	"icon_only_padding__s3_x": "4px",
	"icon_only_padding__s3_y": "4px",
	"icon_only_icon_size__s1": "icon.icon_size__s3",
	"icon_only_icon_size__s2": "20px",
	"icon_only_icon_size__s3": "icon.icon_size__s5",
	"icon_only_border_radius": "corner_radius.circle",
	"gap__s1": "24px",
	"gap__s2": "16px",
	"gap__s3": "8px",
	"social_gap": "8px 16px",
	"accordion_padding__y": "20px"
};

export const field = {
	"padding__s1_x": "16px 24px",
	"padding__s1_y": "12px 16px",
	"border_size__default": "1px",
	"border_size__focus": "2px",
	"button_inset": "6px",
	"border_radius__s1": "0px",
	"border_radius__s2": "0px",
	"min_width": "270px",
	"max_width": "340px"
};

export const form = {
	"gap": "16px 24px"
};

export const icon = {
	"icon_size__s0": "icon.icon_size__s3",
	"icon_size__s1": "64px 88px",
	"icon_size__s2": "48px 72px",
	"icon_size__s3": "28px",
	"icon_size__s4": "24px",
	"icon_size__s5": "16px",
	"stroke_size__s1": "2",
	"stroke_size__s2": "1.5",
	"stroke_size__s3": "1",
	"external_link_size": "0.9em",
	"external_link_margin": "0.2em"
};

export const image = {
	"scale__s1_default": 1,
	"scale__s1_hover": 1.05,
	"scale__s1_active": 1.03
};

export const jump_nav = {
	"layout_switch": "b4"
};

export const pullquote = {
	"layout_switch": "b5",
	"caption_gap": "16px",
	"image_size__s1": "200px 320px",
	"image_size__s2": "56px 80px",
	"inset": "24px"
};

export const reveal = {
	"bp_small": "b3",
	"bp_medium": "b5",
	"bp_large": "b7"
};

export const site_logo = {
	"ratio_masthead": 3.92,
	"width_masthead_unstuck": "141px 180px",
	"width_masthead_stuck": "80px 96px",
	"ratio_footer": 6.76,
	"width_footer": "262px 381px",
	"width_footer_mcm2": "157px",
	"ratio_footer_mcm2": 2.849,
	"offset_y_masthead_unstuck": "0px",
	"offset_y_masthead_stuck": "11px 11px",
	"ratio_masthead_mcm2": 2.84,
	"width_masthead_unstuck_mcm2": "125px 126px",
	"width_masthead_stuck_mcm2": "68px 70px"
};

export const tab_anchor = {
	"gap__x": "24px 60px",
	"gap__y": "16px"
};

export const tag = {
	"padding__x": "4px",
	"padding__y": "4px",
	"border_size": "1px"
};

export const base_card = {
	"v1_bp_horizontal": "b3",
	"v1_bp_image_grow": "b5",
	"v2_bp_horizontal": "b2",
	"v2_bp_text_dominant": "b3",
	"v2_bp_split_footer": "b4",
	"v3_bp_horizontal": "b3",
	"v3_bp_compact": "b4",
	"size_bp_s2": 360,
	"size_bp_s1": 640
};

export const event_card = {
	"v1_horizontal": "b3",
	"v1_image_balanced": "b5",
	"v2_horizontal": "b4",
	"v2_image_visible": "b6"
};

export const expert_card = {
	"bp_footer_align": "b5",
	"mark_size__mcm2": 0.748,
	"mark_offset__mcm2": 0.124,
	"portrait_size": "185px 250px",
	"band_gap": "32px 40px",
	"text_inset": "32px",
	"name_gap": "8px 16px",
	"industries_gap": "32px 40px",
	"bullet_gap": "8px",
	"bullet_size": "8px",
	"text_pad_bottom": "24px",
	"footer_inset__x": "32px",
	"footer_inset__y": "24px",
	"footer_min_height": "140px",
	"post_gap": "16px",
	"post_mark_gap": "16px",
	"post_meta_gap": "12px",
	"tag_inset": "4px"
};

export const home_hero_card = {
	"stack_gap": "16px",
	"meta_gap": "4px",
	"stamp_gap": "16px"
};

export const person_card = {
	"text_padding__top": "16px",
	"text_padding__right": "24px",
	"role_gap": "8px",
	"mark_size": "21px",
	"mark_padding": "0px"
};

export const accordion = {
	"button_icon_size": "24px",
	"item_gap": "22px",
	"icon_offset__y": "6px",
	"list_measure": "656px",
	"header_measure": "800px"
};

export const anchor_card_group = {
	"card_mark_offset": "45%",
	"bp_grid": "b4",
	"bp_grid__tablet": "b5",
	"bp_grid__desktop": "b6",
	"bp_expertise_grid__desktop": "b7",
	"bp_expertise_title__full": "b8",
	"mark_x__1": "-68%",
	"mark_y__1": "-158%",
	"mark_w__1": "393%",
	"mark_h__1": "437%",
	"mark_x__2": "-167%",
	"mark_y__2": "-128%",
	"mark_w__2": "300%",
	"mark_h__2": "333%",
	"mark_x__3": "28%",
	"mark_y__3": "-3%",
	"mark_w__3": "394%",
	"mark_h__3": "438%",
	"mark_w__mcm2": "80.09%",
	"header_max_width": "656px",
	"blurb_min_height__mcm2": "132px",
	"blurb_gap__mcm2": "40px",
	"band_end__mcm2": "40px",
	"card_min_height": "478px",
	"panel_min_height": "609px",
	"panel_padding": "36px",
	"panel_min_height__stacked": "460px",
	"expertise_panel_min_height": "659px",
	"expertise_panel_padding_inline": "32px",
	"expertise_panel_padding_block": "40px",
	"expertise_title_min_height": "129px",
	"expertise_title_max_width": "300px",
	"expertise_title_size__compact": "32px",
	"expertise_content_gap": "40px",
	"expertise_icon_size": "100px",
	"expertise_paragraph_gap": "24px",
	"expertise_list_gap": "8px",
	"anchor_gap": "12px",
	"anchor_dash_length": "2px",
	"anchor_dash_gap": "8px"
};

export const callout = {
	"band_padding__top": "64px 80px",
	"band_padding__bottom": "0px 40px",
	"band_padding__top__mcm2": "40px",
	"kicker_gap": "40px",
	"panel_padding": "40px",
	"content_gap": "24px",
	"text_max_width": "888px",
	"mark_aspect": 0.6457,
	"mark_1_width": "1113px",
	"mark_1_x": "939px",
	"mark_1_lift": "727px",
	"mark_2_width": "999px 1275px",
	"mark_2_x": "115px 179px",
	"mark_2_lift": "643px 1601px"
};

export const expertise = {
	"layout_switch": "b5",
	"mark_width": "168px",
	"mark_aspect": 0.9218,
	"mark_offset__narrow": "57px",
	"mark_offset__wide": "117px",
	"mark_band_height": "240px",
	"rule_ratio__1": 0.0563,
	"rule_ratio__2": 0.9396,
	"content_offset": "120px",
	"stack_gap": "40px 64px",
	"link_gap": "24px",
	"column_gap": "40px",
	"list_pad_bottom": "64px 80px",
	"row_inset__start": "40px",
	"row_inset__end": "44px",
	"label_max_width": "175px",
	"label_gap": "16px"
};

export const experts = {
	"bp_stack": "b5",
	"abstract_max_width": "678px",
	"link_gap": "32px",
	"header_gap": "60px 80px"
};

export const feed = {
	"bp_featured_layout_1": "b5",
	"bp_featured_layout_2": "b6",
	"perspectives_bp_grid": "b5",
	"perspectives_mark_width": "276.28%",
	"perspectives_mark_1_x": "26.66%",
	"perspectives_mark_1_y": "-85.29%",
	"perspectives_mark_2_x": "17.77%",
	"perspectives_mark_2_y": "-1.47%",
	"perspectives_mark_3_x": "-53.26%",
	"perspectives_mark_3_y": "-37.39%",
	"perspectives_mark_4_x": "10.46%",
	"perspectives_mark_4_y": "-0.61%",
	"listing_bp_row": "b6",
	"gap__x": "20px 40px",
	"gap__y": "40px 80px",
	"perspectives_card_min_height": "402px",
	"perspectives_card_padding_end": "64px",
	"perspectives_abstract_gap__stacked": "48px",
	"perspectives_title_max_width": "512px",
	"perspectives_abstract_max_width": "451px",
	"perspectives_mark_aspect": 0.6459,
	"six_across_item_min_width": "190px",
	"mcm2_mark_width": "79px",
	"mcm2_mark_stroke": "31px",
	"listing_meta_width": "316px",
	"listing_image_width": "345px",
	"listing_row_height": "240px",
	"listing_header_gap": "8px",
	"listing_abstract_max_width": "596px",
	"posts_card_inner_gap": "rhythm.tiny",
	"posts_card_inner_gap__s1": "gutter.s2",
	"card_meta_gap": "4px"
};

export const filter = {
	"layout_switch_2": "b5",
	"drawer_width": "304px 368px"
};

export const image_grid = {
	"layout_switch": "b5",
	"logo_knockout": "brightness(0)",
	"padding__top": "32px 64px",
	"padding__bottom": "64px 80px",
	"stack_gap": "40px",
	"column_inset": "20px",
	"row_gap": "40px",
	"row_rule_gap": "32px",
	"cell_min_height": "50px 101px",
	"logo_max_width": "180px"
};

export const media_duo = {
	"mark_size": "117px 183px",
	"mark_offset__top": "36px 56px",
	"mark_offset__end": "51px 80px",
	"mark_dashes__top": "58px 90px",
	"mark_dash_length": "8px",
	"mcm2_mark_size": "90px 195px",
	"mcm2_mark_offset__top": "28px 56px",
	"mcm2_mark_gap": "24px 40px",
	"anchor_gap": "17px",
	"anchor_dash_length": "2px",
	"anchor_dash_gap": "8px"
};

export const media_feature = {
	"media_radius": "0px"
};

export const offering_list = {
	"label_column": "140px 194px",
	"column_gap": "40px 116px",
	"item_gap": "24px",
	"head_gap": "40px"
};

export const partner_companies = {
	"layout_switch": "b5",
	"logo_knockout": "brightness(0) invert(1)",
	"card_gap": "20px",
	"stack_gap": "32px",
	"abstract_max_width": "365px",
	"logo_band_height": "80px",
	"logo_column_width": "275px",
	"logo_column_height": "130px",
	"logo_max_width": "130px",
	"logo_max_height": "42px",
	"divider_gap": "20px",
	"mark_gap": "20px"
};

export const scroll_lock = {
	"layout_switch": "b5"
};

export const sidebar = {
	"layout_switch_1": "b7",
	"layout_switch_2": "b8",
	"header_gap": "24px",
	"padding__x": "16px",
	"padding__y": "14px"
};

export const simple_promo = {
	"mcm2_mark_column_width": 17.028,
	"mcm2_mark_column_bleed": 22.286,
	"mcm2_mark_column_width__stacked": 31,
	"mark_curve_width__stacked": 125.96,
	"mark_curve_x__stacked": 10.577,
	"mark_curve_lift__stacked": 52.16,
	"content_gap": "rhythm:medium",
	"band_padding": "20px 40px",
	"panel_padding": "20px 40px",
	"panel_content_gap": "24px",
	"title_max_width": "888px",
	"plain_padding__top": "40px 80px",
	"plain_padding__bottom": "24px 40px",
	"maroon_padding": "40px 80px",
	"maroon_min_height": "492px",
	"band_text_gap": "16px",
	"band_content_gap": "24px 40px",
	"band_title_max_width": "938px",
	"band_abstract_max_width": "524px",
	"mark_curve_width": "1703px",
	"mark_curve_aspect": 0.6461,
	"mark_curve_x": "143px",
	"mark_curve_lift": "1375px",
	"mark_circles_width": "2131px 3271px",
	"mark_circles_aspect": 1.0005,
	"mark_circles_x": "878px 915px",
	"mark_circles_lift": "1155px 1785px",
	"mcm2_mark_column_aspect": 0.5556
};

export const slideshow = {
	"swiper_speed": 360,
	"caption_transition": 480,
	"height": "200px 596px",
	"gap": "12px 40px",
	"button_border_radius": "corner_radius.circle",
	"rule_inset": "20px",
	"caption_gap": "20px",
	"index_column": "192px",
	"nav_gap": "8px",
	"nav_padding": "8px",
	"nav_icon_size": "24px",
	"item_gap": "16px"
};

export const tab_group = {
	"layout_switch_after_tabs": "b2",
	"layout_switch_non_scrollable": "b4",
	"layout_switch_tabs_and_after_aligned": "b5",
	"item_gap": "20px 40px"
};

export const wysiwyg = {
	"drop_cap_margin__top": "-4px -24px",
	"drop_cap_margin__bottom": "0.1em",
	"drop_cap_margin__left": 0,
	"drop_cap_margin__right": "0.15em",
	"drop_cap_margin__top_firefox": "6px 8px"
};

export const basic_hero = {
	"text_inset__end": "80px",
	"abstract_max_width": "562px",
	"mark_size": "68px",
	"mark_offset__bottom": "20px",
	"mark_rule_overhang__x": "104px",
	"mark_rule__y": "680px",
	"mark_rule_offset__y": "31px",
	"mark_dash_length": "10px",
	"mcm2_mark_size": "64px",
	"mcm2_mark_lift": "12px"
};

export const hero = {
	"layout_switch": "b4"
};

export const page_hero = {
	"sidebar_gap": "24px",
	"line_art_height": "106px 166px",
	"line_art_gap": "24px",
	"stacked_clearance": "40px",
	"line_art_dashes__top": "92px 143px",
	"line_art_dash_length": "10px",
	"line_art_ring_size__s1": "239px 373px",
	"line_art_ring_size__s2": "104px 163px",
	"line_art_ring_offset__s2_left": "234px 365px",
	"line_art_ring_offset__s2_top": "26px 41px",
	"mcm2_mark_width": "630px",
	"mcm2_mark_height": "150px",
	"mcm2_mark_drop": "62px"
};

export const search_hero = {
	"field_border_radius": "corner_radius.pill"
};

export const spotlight_hero = {
	"layout_switch": "b4",
	"feed_switch": "b6",
	"overlay_opacity": 0.75,
	"rotation_interval": "3200ms",
	"line_art_x1__v2": 61.875,
	"line_art_x2__v2": 96.528,
	"line_art_ring__v2": 52.576,
	"band_min_height": "660px",
	"text_max_width": "1020px",
	"heading_icon_size": "icon.icon_size__s1",
	"subtitle_max_width": "630px",
	"text_max_width__v2": "582px",
	"scroll_hint_inset__v2": "24px",
	"scroll_hint_gap__v2": "48px",
	"line_art_inset__v2": "81px",
	"text_offset__top__v2": "0px 24px",
	"rotator_clip_bleed": "0.15em",
	"text_gap": "24px",
	"text_offset__top": "0px 116px",
	"feed_padding__y": "24px 36px",
	"feed_padding__gutter": "24px",
	"feed_padding__trail": "40px",
	"feed_link_column": "347px",
	"feed_link_padding__y": "36px",
	"feed_link_min_height": "112px 150px",
	"feed_mark_size": "155px",
	"feed_mark_offset__top": "21px",
	"feed_mark_offset__right": "11px 40px",
	"feed_dashes__top": "88px 99px",
	"feed_dash_length": "8px"
};

export const expandable = {
	"drawer_padding__x": "20px 32px",
	"drawer_padding__y": "16px 24px"
};

export const masthead = {
	"layout_switch_show_cta": "b5",
	"layout_switch_desktop_1": "b5",
	"layout_switch_desktop_2": "b7",
	"is_megamenu_behind_masthead": false,
	"panel_padding__x": "56px",
	"panel_padding__y": "52px",
	"panel_spacing__top": "56px",
	"height_with_utility_nav": "102px 130px",
	"height_without_utility_nav": "68px 96px",
	"nav_primary_height": "60px 72px",
	"nav_primary_offset_stuck": "-2px -4px",
	"nav_primary_gap": "16px 40px",
	"icon_inset": "-4px",
	"nav_primary_padding__y": "16px 24px",
	"nav_primary_padding__top": "4px 8px",
	"nav_secondary_gap": "16px 24px",
	"nav_secondary_padding__y": "8px",
	"nav_dropdown_padding__x": "24px",
	"nav_dropdown_padding__y": "14px",
	"nav_dropdown_min_width": "200px",
	"nav_dropdown_max_width": "280px",
	"nav_mobile_width": "304px 456px",
	"nav_mobile_padding__x": "space.edge",
	"nav_mobile_padding__y": "64px",
	"nav_mobile_spacing__top": "52px",
	"nav_mobile_spacing__group": "64px",
	"nav_mobile_gap": "24px",
	"nav_mobile_item_padding__y": "16px",
	"nav_mobile_dropdown_padding__left": "20px",
	"nav_mobile_dropdown_padding__y": "12px",
	"nav_mobile_search_padding__x": "19px",
	"nav_mobile_search_padding__y": "12px",
	"nav_mobile_search_height": "46px",
	"nav_mobile_search_placeholder_opacity": 0.5,
	"megamenu_padding__y": "24px 48px"
};

export const megamenu = {
	"layout_switch_bleed": "1441px",
	"intro_column": "464px",
	"intro_inset": "40px",
	"card_padding": "32px",
	"card_min_height": "190px",
	"card_text_gap": "4px",
	"card_icon_stroke": "0.5"
};

export const modal = {
	"width__wide": "480px 1024px",
	"width__narrow": "480px 640px",
	"padding__outer": "20px 80px",
	"padding__inner": "20px 80px",
	"close_inset": "12px"
};

export const page_footer = {
	"layout_switch": "b5",
	"padding__y": "40px 64px",
	"legal_padding__y": "16px",
	"brand_gap": "40px 80px",
	"identity_gap": "24px 40px",
	"intro_gap": "24px",
	"abstract_width": "293px",
	"contact_gap": "16px",
	"contact_rule_height": "31px",
	"social_size": "32px",
	"companies_gap": "16px",
	"group_gap": "24px",
	"group_item_gap": "16px",
	"group_rule_gap": "16px",
	"services_width": "188px",
	"industries_column_gap": "40px",
	"industries_column_width": "189px",
	"legal_gap": "24px"
};

export const pattern_params = { anchor, button, field, form, icon, image, jump_nav, pullquote, reveal, site_logo, tab_anchor, tag, base_card, event_card, expert_card, home_hero_card, person_card, accordion, anchor_card_group, callout, expertise, experts, feed, filter, image_grid, media_duo, media_feature, offering_list, partner_companies, scroll_lock, sidebar, simple_promo, slideshow, tab_group, wysiwyg, basic_hero, hero, page_hero, search_hero, spotlight_hero, expandable, masthead, megamenu, modal, page_footer };
export default pattern_params;
